import eProfileView from '../components/TabContent/Profiles/Models/Enums/eProfileView';
import eCustomRemediationView from '../components/TabContent/Remediation/CustomRemediation/Models/Enums/eCustomRemediationView';
import eRemediationTab from '../components/TabContent/Remediation/Models/Enums/eRemediationTab';
import ePlayBookView from '../components/TabContent/Remediation/PlayBooks/Models/Enums/ePlayBookView';

export default {
  hasEditSettingsPermissions: false,
  globalSettings: {},
  scanGroups: [],
  scanAccounts: [],
  groupInformation: {},
  scanPopulation: {
    HostsPopulation: [],
    IpPopulation: [],
    AdPopulation: []
  },
  groupScheduling: [],
  adSyncResult: [],
  advancedSettingsConnectivity: {},
  advancedSettingsPrivacy: {},
  advancedMasterSlave: {},
  advancedDomainsWhiteListing: [],
  advancedScanThrottling: {},
  advancedRemediationConfiguration: {},
  advancedDecoyFilesListeningPort: 0,
  advancedUiTimeoutMinutes: 0,
  advancedPoliciesExcludes: [],
  advancedSignatures: [],
  advancedErrrors: {},

  //configuration
  excludedIpRanges: [],
  syslogSettings: [],

  //configuration - local network filter
  enableLocalNetworkFilter: true,

  //configuraion - proxy
  selectedProxyParser: '',
  selectedProxyFolder: '',
  proxyParsers: [],
  proxyParsersFolders: [],
  validationLineResult: {},
  validationLine: '',

  //configuraion - vpn
  selectedVpnParser: '',
  selectedVpnFolder: '',
  vpnParsers: [],
  vpnParsersFolders: [],
  vpnValidationLineResult: {},
  vpnValidationLine: '',
  userAdParams: [],
  userCsvParams: [],

  //elasticsearch
  configurationES: {},
  esStatus: {},

  //users
  users: [],

  //analysis
  analysisSmartSimulation: {},

  //alerts
  alertsGeneralSettings: {},
  alertsAutoHostScan: [],
  alertMinimumSeverity: 0,

  //system info
  systemInfo: {},

  //open customer ticket
  openTicketStatus: {},

  //maps settings
  mapsData: [],
  editRegions: false,
  editRegionsMapId: null,
  regionData: [],

  //eps configuration
  selectedSignatureId: -1,
  signatures: [],

  // Active Directory
  activeDirectoryGroups: [],
  activeDirectoryIdentitiesEnabled: [],
  connectionsAD: [],
  authenticationMode: 0,

  // AWS S3
  s3Settings: [],
  s3BucketSettings: [],
  auditsS3SettingsToBucketSettings: [],
  alertsS3SettingsToBucketSettings: [],

  //vulnerability management
  selectedVulnerabilityTabId: 0,
  windowsCriticalPatches: [],
  riskyApplications: [],
  outdatedApplications: [],
  runningApplications: [],

  // Uba Evnets
  ubaEvents: [],

  //threat hunting
  threatHuntingSearchCriteria: [],
  threatHuntingSearchMeta: { isSuppress: false, severity: 3 },

  //decoy files
  decoyFilesArray: [],
  decoyGroupsAndFolders: [],
  GroupWithDecoyEnabled: [],

  // windows events
  windowsEventsProfiles: [],

  // storage devices
  storageDevicesProfiles: [],
  storageDevicesVendorsAndProducts: [],
  storageDeviceError: '',

  //quick storage device exceptions tab
  quickStorageDeviceProfile: null,
  quickStorageDeviceProfiles: [],

  //whitelisting
  whitelistingRulesViewState: eProfileView.ProfileList,
  whitelistingRulesProfiles: [],
  whitelistingExclusionRulesProfiles: [],
  whiteListRulesType: [],
  whiteListRulesAlerts: [],
  whitelistingCriteria: [],
  whitelistingRulesError: '',
  whitelistingExclusionError: '',
  whitelistingRulesScanGroups: [],
  whitelistingRulesHostOptions: [],

  //quick Whitelisting
  quickWhiteListingProfile: null,

  //file monitor

  fileMonitorProfiles: [],
  FileMonitorViewState: eProfileView.ProfileList,
  FileMonitorError: '',

  // Configuration
  excludedHostNames: [],

  /* remediation */
  remediationIsLoading: false,
  selectedRemediationTabId: eRemediationTab.CustomRem.value,

  //custom rem
  customRemediationViewState: eCustomRemediationView.CustomRemList,
  customRemediations: [],
  currentEditedCustomRemediation: {},
  //WE
  windowsEventsConfig: [],
  windowsEventsInterval: 30,

  //playbooks
  playbookViewState: ePlayBookView.PlayBookList,
  playBooks: [],
  playBookForm: {},

  //custom remediation execution servers
  customRemediationExecutionServers: [],
  customRemediationHasAvailableExecutionServers: false,

  // deception user
  deceptionUserConfiguration: [],
  deceptionUsersToDeny: [],

  // deception network
  deceptionNetMaxDecoyHosts: 0,
  deceptionNetSelectedScanGroupId: 0,
  deceptionNetConfigurationForGroup: [],
  deceptionNetIsMultiSelectChecked: false,
  deceptionNetOsVersions: [],

  // tv mode
  tvModeToken: '',

  //CISO KIT
  cisoKitConnections: [],
  enableIPhoneConnection: false,
  enableIPadConnection: false,
  isCisoKitEnabled: false,

  //proxy
  webProxies: [],

  //----------globals ----------------
  userTags: [],
  userClientTypes: [],

  globalServerVersion: '0.0.0.0',
  siteBillingSettings: {},

  /* global-defined mgmnt */
  sites: [],
  usersByLoggedInUser: [],
  allSlavesSites: [],

  allSlavesSystemStatus: [],
  shouldShowEdit: false,

  //SIEM
  siemSlaveSitesSettings: [],
  siemSlaveSitesStatuses: [],
  siemAllSettings: {},
  globalManagmentSiemSettings: {},

  //scangroups
  scanGroupFeatures: [],
  selectedScanGroupFeatureId: 0,
  slaveSitesScanGroups: [],
  slaveSitesScanGroupsStatus:
    [] /* represents the status message of a slave site(per slave site), when clicking save-all */,
  multipleEditScanGroup: {} /* represents a group edit form which will affect all the slave sites  */,
  //site config

  slaveSitesConfig: [],
  multipleEditConfigValue: {},

  //Cloud Email recipients
  SitesEmailRecipients: [],
  multipleEditEmailRecipientsValue: {},

  //Whitelist
  siteWhitelistingRulesError: '',
  sitesWhitelistingRulesProfiles: [],

  //Exclusion
  siteExclusionRulesError: '',
  sitesExclusionRulesProfiles: [],

  //----------end of global ------------
  //advanced reports scheduling
  advancedReportsSchedules: [],

  isGridBlocked: false,
  siteTogglingError: ''
};
